export default "__VITE_ASSET__BaqCM6Ei__"